<mat-card class="notification-card" *ngIf="!notification.hide">
  <div class="notification-content">
    <button mat-icon-button *ngIf="notification.closeNotification" (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
    <!-- <div [innerHTML]="safeHtmlName" ></div> -->
    <div [innerHTML]="safeHtmlContent" class="message-content"></div>
  </div>
</mat-card>
